import * as R from 'ramda';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import postForm from 'utils/postForm';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { createSelector } from 'reselect';
import getUserData from 'selectors/getUserData';

// const getInitialValues = createSelector(
//   R.pipe(
//     getUserData,
//     R.prop('customer'),
//   ),
//   R.applySpec({
//     name: R.prop('name'),
//     customerId: R.prop('id'),
//   }),
// );

// const mapStateToProps = state => ({
//   initialValues: getInitialValues(state),
// });

// @todo: Reload on save
const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(
    postForm(
      'customer',
      R.prop('customerId', data),
      'patch'
    )(data)
  ),
});

const OrganisationEditForm = compose(
  withProps({
    fields: [
      {
        type: 'text',
        name: 'name',
        label: 'Customer name',
        required: true,
      },
      // {
      //   type: 'text',
      //   name: 'type',
      //   label: 'Customer type',
      //   disabled: true
      // },
      // {
      //   type: 'text',
      //   name: 'industry',
      //   label: 'Industry',
      //   disabled: true,
      // },
      // {
      //   type: 'text',
      //   name: 'sector',
      //   label: 'Sector',
      //   disabled: true,
      // },
      {
        type: 'text',
        name: 'customerId',
        label: 'Customer ID',
        required: true,
        hidden: true,
      },
    ],
  }),
  connect(
    // mapStateToProps,
    null,
    mapDispatchToProps,
  ),
)(FormBuilder);

export default OrganisationEditForm;

